import fileTypeImageIcon from '../assets/images/file-type-jpg-icon.svg';
import fileTypePdfIcon from '../assets/images/file-type-pdf-icon.svg';
import fileTypeDocIcon from '../assets/images/file-type-doc-icon.svg';
import fileTypeXlsIcon from '../assets/images/file-type-xls-icon.svg';
import fileTypeMovIcon from '../assets/images/file-type-mov-icon.svg';
import fileTypeOtherIcon from '../assets/images/file-type-other-icon.svg';

import greyFileTypeImageIcon from '../assets/images/grey-file-type-jpg-icon.svg';
import greyFileTypePdfIcon from '../assets/images/grey-file-type-pdf-icon.svg';
import greyFileTypeDocIcon from '../assets/images/grey-file-type-doc-icon.svg';
import greyFileTypeXlsIcon from '../assets/images/grey-file-type-xls-icon.svg';
import greyFileTypeMovIcon from '../assets/images/grey-file-type-mov-icon.svg';
import greyFileTypeOtherIcon from '../assets/images/grey-file-type-other-icon.svg';
import greyFileTypeInspectionIcon from '../assets/images/grey-question-icon.svg';
import greyFormsIcon from '../assets/images/grey-forms-icon.svg';
import greyCheckoffIcon from '../assets/images/grey-checkoff-icon.svg';

import greyFileDocIcon from '../assets/images/solid-grey-doc.svg';
import greyFilePdfIcon from '../assets/images/solid-grey-pdf.svg';
import greyFileExcelIcon from '../assets/images/solid-grey-excel.svg';
import greyFileOtherIcon from '../assets/images/solid-grey-other.svg';
import csTypeQuestionIcon from '../assets/images/question-icon.svg';
import csTypeCheckoffChecked from '../assets/images/checkoff-checked.svg';
import csTypeCheckoffUnchecked from '../assets/images/checkoff-unchecked.svg';
import csTypeFormIcon from '../assets/images/forms-icon.svg';
import answerYes from '../assets/images/answer-yes-selected.svg';
import answerNO from '../assets/images/answer-no-selected.svg';
import answerNA from '../assets/images/answer-na-selected.svg';
import answerNASmall from '../assets/images/na-indicator.svg';
import answerYesSmall from '../assets/images/yes-indicator.svg';
import answerNoSmall from '../assets/images/no-indicator.svg';

import copyIconWhite from '../assets/images/copy-icon.svg';
import copyIconBlack from '../assets/images/copy-icon-black.svg';

import cancelIconWhite from '../assets/images/cancel-icon-white.svg';

import * as LoadImage from 'blueimp-load-image';

let hasToBlobSupport =
  typeof HTMLCanvasElement != 'undefined'
    ? HTMLCanvasElement.prototype.toBlob
    : false;

let hasBlobSupport =
  hasToBlobSupport ||
  (typeof Uint8Array != 'undefined' &&
    typeof ArrayBuffer != 'undefined' &&
    typeof atob != 'undefined');

let hasReaderSupport =
  typeof FileReader != 'undefined' || typeof URL != 'undefined';

export default class ImageTools {

  static getInspectionAnswerIcon(completionStep, small = false) {
    if (completionStep.completion_type == 'inspection') {
      if (completionStep.response == 'YES') {
        return small ? answerYesSmall : answerYes;
      }
      else if (completionStep.response == 'NO'){
        return small ? answerNoSmall : answerNO;
      }
      else if (completionStep.response == 'N/A') {
        return small ? answerNASmall : answerNA;
      }
    }
    return null;
  }

  static getCopyIcon(color){
    if(color.toLowerCase() == 'white'){
      return copyIconWhite;
    }
    else if(color.toLowerCase() == 'black'){
      return copyIconBlack;
    }
  }

  static getCancelIcon(color){
    if(color.toLowerCase() == 'white'){
      return cancelIconWhite;
    }
  }

  static getIconForFile(extension, color) {
    if(extension){
      switch (extension.toLowerCase()) {
      case 'png':
      case 'jpeg':
      case 'jpg':
      case 'gif':
        return fileTypeImageIcon;
      case 'doc':
      case 'docx':
      case 'dotx':
      case 'dot':
      case 'dotm':
        return !color ? fileTypeDocIcon : greyFileDocIcon;
      case 'pdf':
        return !color ? fileTypePdfIcon : greyFilePdfIcon;
      case 'xls':
      case 'xlt':
      case 'xlm':
      case 'xlsm':
      case 'xlsx':
      case 'xltx':
        return !color ? fileTypeXlsIcon : greyFileExcelIcon;
      case 'mp4':
      case 'mov':
      case 'avi':
      case 'wmv':
      case 'flv':
        return fileTypeMovIcon;
      default:
        return !color ? fileTypeOtherIcon : greyFileOtherIcon;
      }
    }
    return !color ? fileTypeOtherIcon : greyFileOtherIcon;
  }

  static getCSIcon(completionStep) {
    if (completionStep.completion_type == 'file_upload') {
      return this.getIconForFile(completionStep.requested_file_type);
    }
    else if (completionStep.completion_type == 'boolean') {
      if (completionStep.not_applicable) {
        return csTypeCheckoffUnchecked;
      }
      else if (completionStep.completed_at) {
        return csTypeCheckoffChecked;
      }
      else {
        return csTypeCheckoffUnchecked;
      }
    }
    else if (completionStep.completion_type == 'inspection') {
      return csTypeQuestionIcon;
    }
    else if (completionStep.completion_type == 'form') {
      return csTypeFormIcon;
    }
  }

  static getGreyedCSIcon(completionStep) {
    if (completionStep.completion_type == 'boolean') {
      return greyCheckoffIcon;
    }
    else if (completionStep.completion_type == 'inspection') {
      return greyFileTypeInspectionIcon;
    }
    else if (completionStep.completion_type == 'form') {
      return greyFormsIcon;
    }

    if (completionStep.requested_file_type) {
      switch (completionStep.requested_file_type.toLowerCase()) {
      case 'png':
      case 'jpeg':
      case 'jpg':
      case 'gif':
        return greyFileTypeImageIcon;
      case 'doc':
      case 'docx':
      case 'dotx':
      case 'dot':
      case 'dotm':
        return greyFileTypeDocIcon; 
      case 'pdf':
        return greyFileTypePdfIcon; 
      case 'xls':
      case 'xlt':
      case 'xlm':
      case 'xlsm':
      case 'xlsx':
      case 'xltx':
        return greyFileTypeXlsIcon; 
      case 'mp4':
      case 'mov':
      case 'avi':
      case 'wmv':
      case 'flv':
        return greyFileTypeMovIcon;
      default:
        return greyFileTypeOtherIcon; 
      }
    }
    return greyFileTypeOtherIcon;
  }

  static resize(file, maxDimensions, exif, callback) {
    let maxWidth = maxDimensions ? maxDimensions.width : null;
    let maxHeight = maxDimensions ? maxDimensions.height : null;

    if(!file) {
      return false;
    }
    else if (!ImageTools.isSupported() || !file.type.match(/image.*/)) {
      callback(file, false, {});
      return false;
    }
    else if (file.type.match(/image\/gif/)) {
      // Not attempting, could be an animated gif
      callback(file, false, {});
      // TODO: use https://github.com/antimatter15/whammy to convert gif to webm
      return false;
    }

    if (exif) {
      let exifData = { dateTimeOriginal: null, latitude: null, longitude: null };
      // NOTE: cordova-camera-with-exif plugin sends exif data natively as 
      // stored by the device hence the multiple tests below
      if (exif.datetime) {
        exifData.dateTimeOriginal = exif.datetime;
      } else if (exif.Exif && exif.Exif.DateTimeOriginal) {
        exifData.dateTimeOriginal = exif.Exif.DateTimeOriginal;
      }
      if (exif.gpsLatitude) {
        const latitudeRef = exif.gpsLatitudeRef;
        const latitudeParts = exif.gpsLatitude.split(',');
        let degMinSec = [];
        for (const part of latitudeParts) {
          const partParts = part.split('/');
          degMinSec.push(parseInt(partParts[0], 10) / parseInt(partParts[1]
, 10));
        }
        exifData.latitude = degMinSec[0] + (degMinSec[1]/60) + (degMinSec[2]/3600);
        if (latitudeRef && latitudeRef == 'S') {
          exifData.latitude = -exifData.latitude;
        }
      } else if (exif.GPS && exif.GPS.Latitude) {
        exifData.latitude = exif.GPS.Latitude;
        if (exif.GPS.LatitudeRef == 'S') {
          exifData.latitude = -exifData.latitude;
        }
      }
      if (exif.gpsLongitude) {
        const longitudeRef = exif.gpsLongitudeRef;
        const longitudeParts = exif.gpsLongitude.split(',');
        let degMinSec = [];
        for (const part of longitudeParts) {
          const partParts = part.split('/');
          degMinSec.push(parseInt(partParts[0], 10) / parseInt(partParts[1]
, 10));
        }
        exifData.longitude = degMinSec[0] + (degMinSec[1]/60) + (degMinSec[2]/3600);
        if (longitudeRef && longitudeRef == 'W') {
          exifData.longitude = -exifData.longitude;
        }
      } else if (exif.GPS && exif.GPS.Longitude) {
        exifData.longitude = exif.GPS.Longitude;
        if (exif.GPS.LongitudeRef == 'W') {
          exifData.longitude = -exifData.longitude;
        }
      }
      if (maxWidth && maxHeight) {
        LoadImage.default(
          file, 
         canvas => {
           canvas.toBlob(blob => {
             if (file.name && !blob.name) {
               blob.name = file.name;
             }
             callback(blob, true, exifData);
           });
         }, 
          {
            canvas: true,
            orientation: true,
            maxHeight,
            maxWidth,
          }
        );
      } else {
        callback(file, true, exifData);
      }
    } else {
      LoadImage.parseMetaData(
        file,
        function(data) {
          let exifData = { dateTimeOriginal: null, latitude: null, longitude: null };
          if (data.exif) {
            exifData.dateTimeOriginal = data.exif.get(0x9003); // DateTimeOriginal
            if (!exifData.dateTimeOriginal) {
              exifData.dateTimeOriginal = data.exif.get(0x0132); // DateTime
            }
            if (exifData.dateTimeOriginal) {
              // timezone is specified in the exif spec but very few
              // implementations set it but we will check anyways
              const exifTimezoneOffset = data.exif[0x882a]; // TimeZoneOffset
              if (exifTimezoneOffset
                  && exifTimezoneOffset.length
                  && exifTimezoneOffset.length >= 1) {
                // offset in hours should be in position 0 (if I read the spec correctly)...
                exifData.dateTimeOriginalOffset = exifTimezoneOffset[0]; // supposed to be in hours
              } else {
                exifData.dateTimeOriginalOffset = (new Date()).getTimezoneOffset() / 60;
              }
            }
            exifData.latitude = data.exif.get(0x0002); // GPSLatitude 
            if (exifData.latitude) {
              const latitudeRef = data.exif.get(0x0001); // GPSLatitudeRef
              exifData.latitude = exifData.latitude[0] + (exifData.latitude[1]/60) + (exifData.latitude[2]/3600);
              if (latitudeRef && latitudeRef == 'S') {
                exifData.latitude = -exifData.latitude;
              }
            }
            exifData.longitude = data.exif.get(0x0004); // GPSLongitude
            if (exifData.longitude) {
              const longitudeRef = data.exif.get(0x0003); // GPSLongitudeRef
              exifData.longitude = exifData.longitude[0] + (exifData.longitude[1]/60) + (exifData.longitude[2]/3600);
              if (longitudeRef && longitudeRef == 'W') {
                exifData.longitude = -exifData.longitude;
              }
            }
          }
          if (maxWidth && maxHeight) {
            LoadImage.default(
              file, 
              canvas => {
                canvas.toBlob(blob => {
                  if (file.name && !blob.name) {
                    blob.name = file.name;
                  }
                  callback(blob, true, exifData);
                },
                file.type && file.type
                );
              }, 
              {
                canvas: true,
                orientation: true,
                maxHeight,
                maxWidth,
              }
            );
          } else {
            callback(file, true, exifData);
          }
        },
        {
          maxMetaDataSize: 262144,
          disableImageHead: false,
        }
      );
    }
  }

  static isSupported() {
    return (
      typeof HTMLCanvasElement != 'undefined' &&
      hasBlobSupport &&
      hasReaderSupport
    );
  }

}



// WEBPACK FOOTER //
// ./src/helpers/ImageTools.js